<template>
  <div>
    <v-item-group :value="l_value" :multiple="multiple" @change="update">
      <template v-if="banner">
        <v-item
          v-for="(item, index) in data"
          :key="index"
          v-slot="{ toggle }"
          :value="item.valueMember"
        >
          <poistenie-banner
            :value="item"
            :data-id="l_dataId"
            :newId="pripad ? pripad.newId : ''"
            :cisloPredmetu="cisloPredmetu"
            :select="()=> onSelect(toggle,item)"
            :add-button="addButton"
            :isOlfs="isOlfs"
            @addButtonClicked="addButtonClicked(item)"
          />
        </v-item>
      </template>
      <template v-else>
        <v-row class="mx-n3 mt-n2 md-flex-column" :class="{ 'mb-3' : !isMobile }">
          <v-col v-for="(item, index) in displayedData" :key="index" xl="3" lg="3" md="4" class="pa-3">
            <v-item v-slot="{ toggle }" :value="item.valueMember">
              <poistenie-card
                :isSelected="getValue() == item.valueMember"
                :value="item"
                :data-id="l_dataId"
                :newId="pripad ? pripad.newId : ''"
                :cisloPredmetu="cisloPredmetu"
                :select="()=> onSelect(toggle,item)"
                :add-button="addButton"
                :isOlfs="isOlfs"
                @addButtonClicked="addButtonClicked(item)"
              />
            </v-item>
          </v-col>
        </v-row>
      </template>
    </v-item-group>
    <template v-if="isMobile && data.length > 3">
      <div class="poistenie-control-show-all">
        <a @click="areItemsShown = !areItemsShown">
          {{ areItemsShown ? "Zobraziť menej" : "Zobraziť všetky" }} 
          <v-icon :class="{'rotate-180': areItemsShown}">mdi-chevron-down</v-icon>
        </a>
      </div>
    </template>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import TextGroup from '../basic/TextGroup';
import PoistenieBanner from './PoistenieBanner.vue';
import PoistenieCard from './PoistenieCard';
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [dynamicControlMixin],
  components: {
    TextGroup,
    PoistenieCard,
    PoistenieBanner,
  },
  watch: {
    areItemsShown(newValue) {
      if(!this.ignoreShowWatcher){
        if (this.l_value != null) {
          this.update(this.l_value);
        } else if (newValue) {
          this.displayedData = this.data;
        } else if (!newValue) {
          this.displayedData = this.data.slice(0, 3);
        }
      }
    },
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      l_value: null,
      mobileItemsToShowPhase: 0,
      data: [],
      displayedData: [],
      displayedDataChanged: false,
      isItemPicked: false,
      areItemsShown: false,
      ignoreShowWatcher: false,
    };
  },
  props: {
    multiple: Boolean,
    banner: Boolean,
    addButton: Boolean,
    preventUnselectWhenSingle:{
      type: Boolean,
      default: false,
    },
    isOlfs:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    readData(config, data) {
      this.ignoreShowWatcher= false;
      this.l_value = null
      this.data = [];
      this.data = data || [];
      this.$emit('dataLoadedStateChanged', this.data.length > 0);
      let show = false;
      if (data && data.length > 0) {
        show = true;
        if (this.isMobile && !this.areItemsShown) {
          this.displayedData = this.data.slice(0, 3);
        } else {
          this.displayedData = this.data;
        }
      }
      this.$emit('itemIsPicked', false)
      if (config.controlValue !== null && config.controlValue !== undefined) {
        
        if (this.isMobile) {
          if (this.areItemsShown) {
            this.displayedData = this.data;
          } else {
            this.movePickedItem(config.controlValue);
            this.displayedData = this.data.slice(0, 1);
          }
          this.$emit('showPoistenieControl',true);
          this.$emit('itemIsPicked', true)
        }

        this.$nextTick(()=>{
          if (this.multiple) {
            this.l_value = config.controlValue.split(',').map(x => +x);
          } else {
            this.l_value = config.controlValue;
          }     
        })
      }
      this.$emit('show', show);
      this.initComplete = true;
    },
    changeItemsShow(value){
      if(value){
        this.ignoreShowWatcher = true;
        this.$emit('showPoistenieControl',!value);
      }else{
        this.ignoreShowWatcher = false;
        if(!this.areItemsShown)
        this.$emit('showPoistenieControl',!value);
        this.areItemsShown = false;
      }
    },
    addButtonClicked(item) {
      this.$emit('addButtonClicked', item.valueMember);
    },
    update(val) {
      //console.log('update', val,this.isLoading);
      if (!this.isLoading) {
        ///console.log("aaaa",val)
        this.setDirty(true);
        this.$emit('input', val);
        this.saveValue(val);
        this.l_value = val;
      }
    },
    getValue() {
      return this.l_value;
    },
    movePickedItem(value) {
      let oznValue = 0;

      if (this.multiple) {
        oznValue = value.split(',').map(x => +x);
      } else {
        oznValue = value;
      } 
      
      let cardIndex = -1;
      
      this.data.forEach((x, index) => {
        if (x.valueMember == oznValue) {
          cardIndex = index;
        }
      });

      if (cardIndex !== -1) {
        let cardItem = this.data.splice(cardIndex, 1)[0];
        this.data.unshift(cardItem);
      }
    },
    onSelect(toggle,item){
      if(this.preventUnselectWhenSingle && !this.multiple && this.data.length === 1 && this.l_value == item.valueMember)
      return;
      return toggle();
    }
  },
  created() {
    if (this.multiple) {
      this.l_value = [];
    }
  },
};
</script>
<style lang="sass"></style>
